import { createAsyncSliceWithDataAndQuery } from '../createAsyncSliceWithDataAndQuery';
import { getConversationContactsAsync } from '../../API/conversations/getConversationContactsAsync';

export const { slice: conversationContactsSlice, asyncAction: loadConversationContactsAction } =
  createAsyncSliceWithDataAndQuery('conversationContactsSlice', getConversationContactsAsync, []);
